import React from 'react'
import { Size } from 'modules/search-bar/types'

type Props = {
    size?: Size
    className?: string
    onClick?: () => void
}

const PlayBoxIcon = ({ size = { width: 30, height: 30 }, className = '', onClick = () => {} }: Props) => (
    <svg
        className={className}
        width={size.width}
        height={size.height}
        viewBox="0 0 45 45"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
    >
        <defs>
            <filter x="-27.8%" y="-25.6%" width="155.6%" height="155.6%" filterUnits="objectBoundingBox" id="filter-2">
                <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
                    type="matrix"
                    in="shadowBlurOuter1"
                ></feColorMatrix>
            </filter>
        </defs>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="play">
                <g id="Group" fillRule="nonzero">
                    <g id="Combined-Shape">
                        <path
                            d="M45,0 L45,45 L0,45 L0,0 L45,0 Z M15.8361817,10.8421053 C15.6927205,10.8421053 15.5537444,10.8821946 15.4192495,10.9623744 L15.4192495,10.9623744 L15.3947368,34.7118137 C15.5023328,34.7986752 15.6390673,34.8421053 15.8049444,34.8421053 C15.9155292,34.8421053 21.795171,31.054965 33.44387,23.4806845 C33.551466,23.393823 33.6052632,23.2902589 33.6052632,23.1699891 C33.6052632,23.0497193 33.551466,22.9461552 33.44387,22.8592937 L33.44387,22.8592937 L16.2396646,10.9623744 C16.1051696,10.8821946 15.9706767,10.8421053 15.8361817,10.8421053 Z"
                            fill="black"
                            fillOpacity="1"
                            filter="url(#filter-2)"
                        ></path>
                        <path
                            d="M45,0 L45,45 L0,45 L0,0 L45,0 Z M15.8361817,10.8421053 C15.6927205,10.8421053 15.5537444,10.8821946 15.4192495,10.9623744 L15.4192495,10.9623744 L15.3947368,34.7118137 C15.5023328,34.7986752 15.6390673,34.8421053 15.8049444,34.8421053 C15.9155292,34.8421053 21.795171,31.054965 33.44387,23.4806845 C33.551466,23.393823 33.6052632,23.2902589 33.6052632,23.1699891 C33.6052632,23.0497193 33.551466,22.9461552 33.44387,22.8592937 L33.44387,22.8592937 L16.2396646,10.9623744 C16.1051696,10.8821946 15.9706767,10.8421053 15.8361817,10.8421053 Z"
                            fill="#FFFFFF"
                        ></path>
                    </g>
                </g>
                <path
                    d="M15.8361817,10.8421053 C15.9706767,10.8421053 16.1051696,10.8821946 16.2396646,10.9623744 L33.44387,22.8592937 C33.551466,22.9461552 33.6052632,23.0497193 33.6052632,23.1699891 C33.6052632,23.2902589 33.551466,23.393823 33.44387,23.4806845 C21.795171,31.054965 15.9155292,34.8421053 15.8049444,34.8421053 C15.6390673,34.8421053 15.5023328,34.7986752 15.3947368,34.7118137 L15.4192495,10.9623744 C15.5537444,10.8821946 15.6927205,10.8421053 15.8361817,10.8421053 Z"
                    id="next-copy-6"
                    fill="#121212"
                    opacity="0.5"
                ></path>
            </g>
        </g>
    </svg>
)

export default PlayBoxIcon
